export const higestRankedCategory = (poi) => {
  if (!poi.categories.length) return { name: '', id: '', color: 'D3D3D3' };

  return poi.categories.reduce(
    (highest, cat) => (highest = cat.id > highest.id ? cat : highest),
    poi.categories[0],
  );
};

export const fetchParkingSpots = (parking, config, lat, lon) =>
  parking.parkopedia.parkingSpots.fetch(
    `${config.gysService.url}/ev/by-geo-location`,
    {
      lat,
      lon,
      uid: config.gysService.ownerId,
      lang: config.gysService.language,
      radius: 3000,
      type: 'OFF_STREET',
    },
  );
